// extracted by mini-css-extract-plugin
export default {"hamburger":"hamburger_hamburger__Qmcom","open":"hamburger_open__RACJZ"};